
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { Router } from '@angular/router';
import { ServerService } from '../../../service/server/server.service';
import { Params, ActivatedRoute } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-install-open-crater',
  templateUrl: './install-open-crater.component.html',
  styleUrls: ['./install-open-crater.component.css']
})

export class InstallOpenCraterComponent implements OnInit, OnDestroy {
  //**********************************************************
  public username: string;
  public server: string;
  public lang: any;
  public loading = false;
  public subscription: Subscription;
  public limit_forms: boolean;
  public err: string; public err_validation: boolean = false;
  public err_internet_text: string; public err_internet_validation: boolean;
  public task_type: number;
  public confirm_delete: boolean;
  public count_total: number; public page_number_first: number; public page_number_second: number; public page: number = 1;
  public code: any;
  user_info: any;
  user_id: number;
  public type: number; public type_search: number;
  @ViewChild('myModal') myModal: any;
  @ViewChild('myModalSearch') myModalSearch: any;
  public pattern_title_with_persian: any;
  //******************************************************************************
  public obj = {};
  public data = {};
  public list_record: any = [];
  public list_status: any = [];
  //******************************************************************************
  public id: number;
  public pre_status: boolean; public next_status: boolean; public new_status: boolean;
  public status_id: number; public status_id_search: number;
  public title: string; public title_search: string;
  price: string;
  //************
  //***********
  public mat_table_selectedRow: any;
  public mat_table_hoverRow: any;
  dataSource;
  displayedColumns = ['row', 'title', 'price', 'status', 'id', 'operation'];
  //*************
  constructor(public serverService: ServerService,
    public ngxSmartModalService: NgxSmartModalService, public router: Router, public activatedRoute: ActivatedRoute, public matSnackBar: MatSnackBar) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(
      (params: Params) => {
        this.code = params['id'];
      }
    )
    this.serverService.status1(2);
    this.server = this.serverService.get_server();
    this.lang = JSON.parse(<any>localStorage.getItem('lang'));
    this.user_info = JSON.parse(<any>localStorage.getItem('user_info'));
    this.username = this.user_info.username;
    this.user_id = this.user_info.user_id;
    this.pattern_title_with_persian = this.serverService.pattern_title_with_persian();
    this.recieve_status();
    this.check_access(4, 1, '');
    //**************
  }//end ngOnInit
  //****************************************************************************
  check_access(type_task, page, id) {
    if (this.serverService.check_internet()['status'] == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_erorr(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, user_id: this.user_id, id: this.code }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            //this.serverService.signout();
            var pe_message = "شما دسترسی به این سرویس را ندارید";
            var pe_action = "بستن";
            this.recieve_erorr(true, 'Access restrictions', pe_message, 1, 'close', pe_action);
          }
          else {
            this.loading = false;
            if (type_task == 1) { this.insert(); }
            if (type_task == 2) { this.update(); }
            if (type_task == 3) { this.delete(id); }
            if (type_task == 4) { this.load_data(page); }
          }
        }//end if
        else {
          var pe_message = "خطا در دسترسی";
          var pe_action = "بستن";
          this.recieve_erorr(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  load_data(page) {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.loading = true;
    if (page == 2) { this.page = this.page + 1; }
    if (page == 4) { this.page = Math.ceil(this.count_total / 20); }
    if (page == 3) { this.page = this.page - 1; }
    if (page == 5) { this.page = 1; }
    if (page == 6) { this.page = 1; }
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 51, "page": this.page, 'type': this.type, user_id: this.user_id, 'title': this.title_search, 'status_id': this.status_id_search }).subscribe(
      (res) => {
        this.data = res;
        if (this.data['status'] == 1) {
          this.list_record = [];
          for (var i = 0; i < this.data['num']; i++) {
            this.list_record.push(this.data['result'][i]);
          }//end for
          this.dataSource = new MatTableDataSource(this.list_record);
          this.count_total = res['count'];
          this.page_number_first = this.page * 20 - 19;
          this.page_number_second = this.page * 20;
          if (this.page_number_first == 1) { this.pre_status = true; this.new_status = false; }
          else { this.pre_status = false; this.new_status = true; }
          if (this.data['num'] < 20) { this.page_number_second = this.count_total; this.next_status = true }//end if
          else { this.next_status = false; }
          this.myModal.close();
          this.myModalSearch.close();
          this.serverService.change_window_resize(2, '', 0);
          this.serverService.send_services_id(this.code);
          this.recieve_erorr(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_erorr(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }//end else
      }//end res:Response
    ) //ens dubscribe
  }//end load data
  //***************************************************************************
  change_task(type, id, title, price, status_id) {
    this.task_type = type;
    this.id = id;
    if (type == 1) {
      this.title = "";
      this.price = "";
      this.status_id = 1;
      this.type = 1;
      this.myModal.open();
    }//end if
    if (type == 2) {
      this.title = title;
      this.price = price;
      this.status_id = status_id;
      this.myModal.open();
    }//end else
    if (type == 3) {
      this.type = 3;
      this.myModalSearch.open();
    }
  }//end change_task

  get_bg(id) {
    this.id = id;
  }
  //***************************************************************************
  insert() {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 52, "username": this.username, 'status_id': this.status_id, 'title': this.title, 'price': this.price }).subscribe(
      (res) => {
        if (res['status'] == 1 && res['num'] == 1) {
          this.list_record.unshift(res['result'][0]);
          this.count_total = this.count_total + 1;
          if (this.count_total > 20) {
            this.list_record.pop();
            this.next_status = false;
          }//end if
          this.dataSource = new MatTableDataSource(this.list_record);
          this.myModal.close();
          this.id = res['result'][0].shop_install_open_crater_id;
          this.recieve_erorr(false, "", "", 1, "", "");
        }//end if
        else if (res['status'] == 4) {
          if (this.lang == '1') {
            alert(' عنوان  مي بايست منحصر به فرد باشد ');
          }//end if
          if (this.lang == '2') {
            alert('The title should be unique');
          }//end if 
          this.recieve_erorr(false, "", "", 1, "", "");
        }
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_erorr(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end insert
  //********************************************************************************
  update() {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 53, "username": this.username, 'title': this.title, 'price': this.price, 'status_id': this.status_id, 'id': this.id }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          for (var i = 0; i < this.list_record.length; i++) {
            if (this.list_record[i].shop_install_open_crater_id == this.id) {
              this.list_record[i].shop_install_open_crater_title = res['result'][0].shop_install_open_crater_title;
              this.list_record[i].shop_install_open_crater_price = res['result'][0].shop_install_open_crater_price;
              this.list_record[i].status_id = res['result'][0].status_id;
              this.list_record[i].status_title = res['result'][0].status_title;
              this.list_record[i].status_title2 = res['result'][0].status_title2;
            }//end if
          }//end for
          this.dataSource = new MatTableDataSource(this.list_record);
          this.myModal.close();
          this.recieve_erorr(false, "", "", 1, "", "");
        }//end if
        else if (res['status'] == 4) {
          if (this.lang == '1') {
            alert(' عنوان  مي بايست منحصر به فرد باشد ');
          }//end if
          if (this.lang == '2') {
            alert('The title should be unique');
          }//end if 
          this.recieve_erorr(false, "", "", 1, "", "");
        }
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_erorr(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end insert
  //********************************************************************************
  delete(id) {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.id = id;
    if (this.lang == '1') {
      this.confirm_delete = confirm("آيا شما از حدف اطمينان داريد ؟");
    }//end if
    if (this.lang == '2') {
      this.confirm_delete = confirm("Are you sure for delete");
    }//end if
    if (this.confirm_delete == true) {
      this.loading = true;
      this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 54, "username": this.username, 'id': id, "page": this.page, 'type': this.type, 'title': this.title_search, 'status_id': this.status_id_search }).subscribe(
        (res) => {
          this.data = res;
          if (this.data['status'] == 1) {
            for (var i = 0; i < this.list_record.length; i++) {
              if (this.list_record[i].shop_install_open_crater_id == id) {
                this.list_record.splice(i, 1);
              }//end if
            }//end for
            if (Object.keys(res['result']).length != 0) {
              this.id = res['result'][0].shop_install_open_crater_id;
              this.list_record.push(res['result'][0]);
            }//end Object.keys
            this.dataSource = new MatTableDataSource(this.list_record);
            this.count_total = this.count_total - 1;
            this.recieve_erorr(false, "", "", 1, "", "");
          }//end if
          else {
            var pe_message = "خطا در حذف";
            var pe_action = "بستن";
            this.recieve_erorr(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
          }//end else
        }//end res:Response
      )//end this.subscription
    }//end this.confirm_delete == true    
  }//end delete
  //*******************************************************************************
  recieve_status() {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 2 }).subscribe(
      (res) => {
        this.list_status = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_status.push(res['result'][i]);
          }//end for
          this.recieve_erorr(false, "", "", 2, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_erorr(true, 'Erorr in recieve', pe_message, 2, 'close', pe_action);
        }
      }
    )
  }//end recieve_status
  //*******************************************************************************
  change_resize() {
    this.serverService.change_window_resize(1, '', 0);
  }//end change_resize
  //*******************************************************************************
  recieve_erorr(validation, en_message, pe_message, type, en_action, pe_action) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(pe_message, pe_action, { duration: 2000 });
    }//end if
    else {
      this.matSnackBar.dismiss();
    }
  }//end 



  ModalClose() {
    this.recieve_erorr(false, "", "", 2, "", "");
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}